(() => {
  angular.module('pims')
    .directive('caretHandler', () => {
      return {
        restrict: 'A',
        scope: {
          caretHandler: '=?'
        },
        controller: function() {
          this.getCaretPositions = () => {
            const { selectionStart: caretStart, selectionEnd: caretEnd } = this.element[0];
            return {caretStart, caretEnd};
          };
        },
        controllerAs: 'caretCtrl',
        link: function(scope, element, attrs, ctrl) {
          ctrl.element = element;

          // Function to set caret position
          function setCaretPosition(elem, pos, autoJump) {
            if (autoJump) {
              if (elem.setSelectionRange) {
                elem.focus();
                elem.setSelectionRange(pos, pos);
              } else if (elem.createTextRange) {
                const range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
              }
            }
          }

          // Validation
          function validate(args) {
            const expectedArgs = ['position', 'autoJump'];
            // Check if the provided attribute matches the expected structure
            if (!angular.isObject(args)) {
              console.error('caretHandler directive requires an object with "position" and "autoJump" properties if provided.');
              return false;
            }
            // Check for unexpected attributes
            if (!expectedArgs.every(arg => Object.keys(args).includes(arg))) {
              console.error('caretHandler directive requires an object with "position" and "autoJump" properties if provided.');
              return false;
            }
            return true;
          }

          // Handle click event if caretHandler args are provided
          function handleClick() {
            if (scope.caretHandler && validate(scope.caretHandler)) {
              setCaretPosition(element[0], scope.caretHandler.position, scope.caretHandler.autoJump);
            }
          }

          // Bind click event if caretHandler args are provided
          if (scope.caretHandler) {
            element.on('click', handleClick);

            scope.$on('$destroy', function() {
              element.off('click', handleClick);
            });
          }
        }
      };
    });
})();
